import { __assign, __awaiter, __generator } from "tslib";
import { webLightTheme } from '@fluentui/react-components';
import { FileType } from '@office-start/document-types';
import { fetchFeatureGates, getFeatureGates, isCodeBehindKillswitchEnabled, } from '@office-start/feature-gates-service';
import { HarmonyAppThemes, OfficeThemeMode, } from '@office-start/theming-types';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { officeStartThemeFromBase } from '../util';
import { createFluentTheme } from './createFluentTheme';
var themeSubject = new BehaviorSubject(webLightTheme);
var themeModeSubject = new BehaviorSubject(OfficeThemeMode.default);
var themeIdSubject = new BehaviorSubject(undefined);
export var globalTheme = themeSubject.asObservable();
export var globalThemeMode = themeModeSubject
    .asObservable()
    .pipe(distinctUntilChanged());
export var globalThemeId = themeIdSubject
    .asObservable()
    .pipe(distinctUntilChanged());
export var themeSnapshot = webLightTheme;
// NOTE: This is not intended for use outside the hooks in this package.
// Any react-facing component or services should source theme information from the useThemeMode and useTheme hooks.
// It is temporarily used within getDocumentActionsCreator that acts as a wrapper for our angular application, which only uses global themes.
export var themeModeSnapshot = OfficeThemeMode.default;
export var themeIdSnapshot = undefined;
export function setGlobalTheme(theme, setFabricTheme, generateLegacyCss) {
    var _a;
    if (setFabricTheme === void 0) { setFabricTheme = false; }
    if (generateLegacyCss === void 0) { generateLegacyCss = false; }
    return __awaiter(this, void 0, void 0, function () {
        var featureGatesResult, featureGates, _b, isMergeStreamClipchampEnabled, isMergeStreamThemeOnHwaEmbedEnabled, officeStartTheme, fluentTheme;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(theme.themeId === FileType.Stream)) return [3 /*break*/, 5];
                    featureGatesResult = getFeatureGates();
                    if (!(featureGatesResult === null || featureGatesResult === void 0 ? void 0 : featureGatesResult.result)) return [3 /*break*/, 1];
                    _b = featureGatesResult;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchFeatureGates()];
                case 2:
                    _b = _c.sent();
                    _c.label = 3;
                case 3:
                    featureGates = (_b).result;
                    isMergeStreamClipchampEnabled = ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.startPageGates) === null || _a === void 0 ? void 0 : _a.startPageIsMergeStreamClipchampEnabled) || false;
                    return [4 /*yield*/, isCodeBehindKillswitchEnabled('killswitchIsMergeStreamThemeOnHwaEmbedEnabled')];
                case 4:
                    isMergeStreamThemeOnHwaEmbedEnabled = _c.sent();
                    if (isMergeStreamClipchampEnabled &&
                        isMergeStreamThemeOnHwaEmbedEnabled) {
                        officeStartTheme = officeStartThemeFromBase(HarmonyAppThemes[FileType.Clipchamp]);
                        theme = __assign(__assign({}, officeStartTheme), { themeId: theme.themeId, mode: theme.mode });
                    }
                    _c.label = 5;
                case 5: return [4 /*yield*/, createFluentTheme(theme)];
                case 6:
                    fluentTheme = _c.sent();
                    if (!setFabricTheme) return [3 /*break*/, 8];
                    // Set legacy theme for v8 and below
                    return [4 /*yield*/, import(
                        /* webpackChunkName: "fabric-theme" */ '../lazy-modules/legacy/loadLegacyFabricTheme').then(function (mod) { return mod.loadLegacyFabricTheme(theme); })];
                case 7:
                    // Set legacy theme for v8 and below
                    _c.sent();
                    _c.label = 8;
                case 8:
                    if (!generateLegacyCss) return [3 /*break*/, 10];
                    // Set legacy theme for OfficeHome
                    return [4 /*yield*/, import(
                        /* webpackChunkName: "office-theme" */ '../lazy-modules/legacy/loadLegacyOfficeTheme').then(function (mod) { return mod.loadLegacyOfficeTheme(theme); })];
                case 9:
                    // Set legacy theme for OfficeHome
                    _c.sent();
                    _c.label = 10;
                case 10:
                    themeSnapshot = fluentTheme;
                    themeSubject.next(fluentTheme);
                    themeModeSnapshot = theme.mode;
                    themeModeSubject.next(theme.mode);
                    themeIdSnapshot = theme.themeId;
                    themeIdSubject.next(theme.themeId);
                    return [2 /*return*/, fluentTheme];
            }
        });
    });
}
//# sourceMappingURL=setGlobalTheme.js.map